import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconLookupDataGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M13.4444 5.5H2.55556C1.69645 5.5 1 6.19645 1 7.05556V17.9444C1 18.8036 1.69645 19.5 2.55556 19.5H13.4444C14.3036 19.5 15 18.8036 15 17.9444V7.05556C15 6.19645 14.3036 5.5 13.4444 5.5Z"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9H1"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 12.5H1"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 16H1"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.00003 7.927C5.92503 7.7185 5.92503 7.48916 6.00003 7.28066C6.73053 5.45293 7.58299 3.78635 9.17525 2.6867C10.7675 1.58704 12.6403 1 14.5563 1C16.4723 1 18.3451 1.58704 19.9373 2.6867C21.5296 3.78635 22.7695 5.3491 23.5 7.17683C23.575 7.38533 23.575 7.61467 23.5 7.82317C22.7695 9.6509 21.5296 11.2136 19.9373 12.3133C18.3451 13.413 16.4723 14 14.5563 14C12.6403 14 10.7675 13.413 9.17525 12.3133C7.58299 11.2136 6.73053 9.75472 6.00003 7.927Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.04375 7.64309C7.98542 7.48593 7.98542 7.31305 8.04375 7.1559C8.61193 5.77822 9.57639 4.60026 10.8148 3.77138C12.0533 2.94249 13.51 2.5 15.0002 2.5C16.4905 2.5 17.9472 2.94249 19.1856 3.77138C20.4241 4.60026 21.3886 5.77822 21.9567 7.1559C22.0151 7.31305 22.0151 7.48593 21.9567 7.64309C21.3886 9.02077 20.4241 10.1987 19.1856 11.0276C17.9472 11.8565 16.4905 12.299 15.0002 12.299C13.51 12.299 12.0533 11.8565 10.8148 11.0276C9.57639 10.1987 8.61193 9.02077 8.04375 7.64309Z"
        fill="white"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0002 9.49876C16.16 9.49876 17.1002 8.55857 17.1002 7.3988C17.1002 6.23902 16.16 5.29883 15.0002 5.29883C13.8405 5.29883 12.9003 6.23902 12.9003 7.3988C12.9003 8.55857 13.8405 9.49876 15.0002 9.49876Z"
        stroke={fillColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const IconLookupDataSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="21"
      viewBox="0 0 25 21"
      {...(props.svg ?? {})}
    >
      <IconLookupDataGroup {...props} />
    </svg>
  );
};
